import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { DeploymentsService } from '../services/deployments.service';
import { DeploymentDetail } from '../models/deployment';

export const tenantDbsResolver: ResolveFn<DeploymentDetail> = (route) => {
    const deploymentId = route.params['id'];
    return inject(DeploymentsService).getDeploymentWithDbStats(deploymentId);
};
